import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { createTextMaskInputElement } from 'text-mask-core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-coleta-advogado',
  templateUrl: './coleta-advogado.component.html',
  styleUrls: ['./coleta-advogado.component.scss']
})
export class ColetaAdvogadoComponent implements OnInit {
  @ViewChild('successModal') successModal!: TemplateRef<any>;
  @ViewChild('errorModal') errorModal!: TemplateRef<any>;

  advogadoForm: FormGroup;
  errorMessage: string ='';

  // Máscaras para os campos
  telefoneMask = ['+', '3', '9', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
  cfMask = [/[A-Z]/, /[A-Z]/, /[A-Z]/, /[A-Z]/, /[A-Z]/, /[A-Z]/, /\d/, /\d/, /[A-Z]/, /\d/, /[A-Z]/, /\d/, /[A-Z]/, /\d/, /[A-Z]/, /[A-Z]/];
  pivaMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private ajaxService: AjaxService,
    public modalService: NgbModal,
    private router: Router,
    private util: UtilService
  ) {
    this.advogadoForm = this.fb.group({
      cognome: ['', Validators.required],
      nome: ['', Validators.required],
      telefono: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      pec: ['', [Validators.required]],
      cf: ['', [Validators.required]],
      piva: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
      indirizzo: ['', Validators.required],
      linguaPortoghese: [false],
      linguaSpagnolo: [false],
      linguaInglese: [false],
      cassazionista: [false]
    }, {
      validators: this.atLeastOneLanguageValidator()
    });
  }

  ngOnInit(): void {
  }

  // Validador personalizado para verificar se pelo menos uma língua está selecionada
  private atLeastOneLanguageValidator() {
    return (formGroup: FormGroup) => {
      const linguaPortoghese = formGroup.get('linguaPortoghese')?.value;
      const linguaSpagnolo = formGroup.get('linguaSpagnolo')?.value;
      const linguaInglese = formGroup.get('linguaInglese')?.value;

      if (!linguaPortoghese && !linguaSpagnolo && !linguaInglese) {
        return { atLeastOneLanguage: true };
      }

      return null;
    };
  }

  // Getter para verificar se há erro de validação de língua
  get hasLanguageError(): boolean {
    return this.advogadoForm.hasError('atLeastOneLanguage') && 
           (this.advogadoForm.get('linguaPortoghese')?.touched || 
            this.advogadoForm.get('linguaSpagnolo')?.touched || 
            this.advogadoForm.get('linguaInglese')?.touched);
  }

  navigateToSection(sectionId: string): void {
    this.router.navigate(['/site'], { fragment: sectionId });
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  onSubmit() {
    if (this.advogadoForm.valid) {
      const formData = this.advogadoForm.value;
    
      let dados = {        
        "COGNOME": formData.cognome,
        "NOME": formData.nome,
        "TELEFONO": formData.telefono,
        "EMAIL": formData.email,
        "PEC": formData.pec,
        "CF": formData.cf,
        "PIVA": formData.piva,
        "INDIRIZZO_STUDIO": formData.indirizzo,
        "LINGUE_PORTOGHESE": formData.linguaPortoghese ? true : false,
        "LINGUE_SPAGNOLO": formData.linguaSpagnolo ? true : false,
        "LINGUE_INGLESE": formData.linguaInglese ? true : false,
        "CASSAZIONISTA": formData.cassazionista ? true : false
      }

      let url = API + "Usuario/Cadastro/advogado";
      // Criar novo advogado
      this.util.showLoading();
      this.ajaxService.post(url, dados).subscribe({
        next: (response) => {
          this.util.closeLoading();
          // Limpar o formulário
          this.advogadoForm.reset();
          
          // Mostrar mensagem de sucesso
          this.modalService.open(this.successModal, { 
            centered: true,
            backdrop: 'static',
            keyboard: false
          });
        },
        error: (error) => {
          this.util.closeLoading();
          //console.error('Erro ao criar advogado:', error);
          this.errorMessage = error.message;
          // Mostrar mensagem de erro
          this.modalService.open(this.errorModal, { 
            centered: true,
            backdrop: 'static',
            keyboard: false
          });
        }
      });
    }
  }

  // Getters para validação dos campos
  get cognome() { return this.advogadoForm.get('cognome'); }
  get nome() { return this.advogadoForm.get('nome'); }
  get telefono() { return this.advogadoForm.get('telefono'); }
  get email() { return this.advogadoForm.get('email'); }
  get pec() { return this.advogadoForm.get('pec'); }
  get cf() { return this.advogadoForm.get('cf'); }
  get piva() { return this.advogadoForm.get('piva'); }
  get indirizzo() { return this.advogadoForm.get('indirizzo'); }
} 